import axios from "axios";
import { API_BASE } from "../config/constants";

export const executiveProgramResource = axios.create({
  baseURL: `${API_BASE}/api/v1/executive-program`,
});

export const executiveFloorsResource = (url, eventId) =>
  axios.create({
    baseURL: `${url}/api/external/event/${eventId}/floor-data`,
  });

export const executiveExhibitorsResource = (url, eventId) =>
  axios.create({
    baseURL: `${url}/api/external/event/${eventId}/virtual-exhibition-data`,
  });

export const boothResource = axios.create({
  baseURL: `${API_BASE}/api/v1/booths`,
  headers: {
    "Content-Type": "application/json",
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const formResource = axios.create({
  baseURL: `${API_BASE}/api/v1/booths-form`,
  headers: {
    "Content-Type": "application/json",
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const verificationResource = axios.create({
  baseURL: `${API_BASE}/api/v1/mcaptcha`,
  headers: {
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const mcaptchaSettingsResource = axios.create({
  baseURL: `${API_BASE}/api/v1/mcaptcha/settings`,
});

export const pageTypeResource = axios.create({
  baseURL: `${API_BASE}/api/v1/pageType`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const attachmentResource = axios.create({
  baseURL: `${API_BASE}/api/v1/attachments`,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: "ApiKey 1d952c05-474f-4006-978b-c4d871d9ae4f",
  },
});
